export const logger = {
  log: (message?: any, ...optionalParams: any[]) => {
    console.log(message, optionalParams)
  },
}
